import * as React from 'react';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import {renderProductType} from '../../../../utils/function/Function';
import { Typography } from '@mui/material';
import Color from '../../../../layouts/Color';

const container = { padding: 2, ml: "-10px" };
const card =  { maxWidth: 345, mt: 2 };
const innerContainer = { padding: 2 };

export default function PreviousInformation(props) {

    const renderContentOfPreviousInformation = (data) => {
        return data.productCode !== null ? (
            <Grid container spacing={3} sx={innerContainer}>
                <Grid item xs={4} sm={4}>
                    <Typography variant="subtitle1" color={Color.Normal}> Product Type: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="subtitle1" color={Color.Normal}> {renderProductType(data.productType)} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="subtitle1" color={Color.Normal}> Product: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="subtitle1" color={Color.Normal}> {data.productName} </Typography>
                </Grid>
            </Grid>) : (<Grid container spacing={3} sx={innerContainer}>
                <Grid item xs={4} sm={4}>
                    Product Type:
                </Grid>
                <Grid item xs={8} sm={8}>
                </Grid>
                <Grid item xs={4} sm={4}>
                    Product:
                </Grid>
                <Grid item xs={8} sm={8}>
                </Grid>
            </Grid>);
    }

    return (
        <React.Fragment>
            <Grid container spacing={3} sx={container}>
                <Card sx={card}>
                    {renderContentOfPreviousInformation(props.step0Data)}
                </Card>
            </Grid>
        </React.Fragment>
    );
}